import * as React from 'react'
import { FC } from 'react'

import { color, FontFamilies } from '../../../../../style/variables'

export interface ActiveSectionProps {
  activeSection: string
  isMenuOpen: boolean
  onClick: () => void
}

const triangleWidth = 32

const ActiveSection: FC<ActiveSectionProps> = ({ activeSection, isMenuOpen, onClick }) => {
  return (
    <>
      <style jsx>{`
        .active-section {
          text-transform: uppercase;
          position: relative;
          padding-right: ${triangleWidth}px;
          height: 63px;
          font-family: ${FontFamilies.barlow};
          font-size: 15px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 4.27;
          letter-spacing: 2px;
          color: ${color.brandPrimary};
          background-image: linear-gradient(to right, #ffffff 0%, #f2f2f2 100%);
          cursor: pointer;
        }
        .triangle-bottom-right {
          position: absolute;
          top: 0px;
          right: 0px;
          width: 0;
          height: 0;
          border-bottom: 63px solid white;
          border-left: ${triangleWidth}px solid transparent;
        }
      `}</style>
      <div className="active-section" onClick={onClick} role="button">
        {isMenuOpen ? 'close' : activeSection}
        <div className="triangle-bottom-right"></div>
      </div>
    </>
  )
}
export default ActiveSection
